const portfolio = [
    {
        id:1,
        size: 'large',
        image:'port-bg-1',
        name: 'Maashaa',
        category: ['all', 'Education', 'Environment']
    },
    {
        id:2,
        size: 'large',
        image:'port-bg-2',
        name: 'Maashaa',
        category: ['all', 'Health', 'Environment'],
    },
    {
        id:3,
        size: 'large',
        image:'port-bg-3',
        name: 'Maashaa',
        category: ['all', 'Education'],
    },
    {
        id:4,
        size: 'large',
        image:'port-bg-5',
        name: ['Maashaa'],
        category: ['all', 'Skill Development and  Rural Livelihoods'],
    },
    {
        id:5,
        size: 'wide',
        image:'port-bg-4',
        name: 'Maashaa',
        category: ['all', 'Education', 'Community Engagement'],
    }
];

export default portfolio